import { __rest } from "tslib";
import * as React from 'react';
import { Redirect, Route } from 'react-router-dom';
const ProtectedRoute = (_a) => {
    var { isAccessible, redirectTo } = _a, props = __rest(_a, ["isAccessible", "redirectTo"]);
    return (React.createElement(Route, Object.assign({}, props, { render: componentProps => (isAccessible ? props.render(componentProps) : React.createElement(Redirect, { to: redirectTo })) })));
};
export default ProtectedRoute;
